import ActionTypes from "../../../constants/ActionTypes";
import { ISetShouldCallLogin } from "./types";


export const setShouldCallLogin = (shouldCallLogin: boolean): ISetShouldCallLogin => ({
  type: ActionTypes.COOKIE.SET_SHOULD_CALL_LOGIN,
  payload: shouldCallLogin
});
